export default __webpack_public_path__ + "static/media/Background_00215.f466a998.png";